import React, { useState, useEffect } from 'react'
import { GetCmsPages } from '../api.services.js/others'
import { Container } from 'react-bootstrap';
import Head from 'next/head';


export const getServerSideProps=async ()=>{
  const response =await GetCmsPages({identifier:"exports-project"});
  return {
    props:{response},
  };
} 
function ExportsProject(props) {
  const [cmsPage,setcmsPage]=useState(props.response.data.cmsPage.content);

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Exports",
        "item": "https://www.orientbell.com/exports-project"
      }]
      }`
    }
  }
   const  myFunction = (x)=> {
    if(x == 'english'){ 
      document.getElementById("englishLang").style.display = "block";
      document.getElementById("spanishLang").style.display = "none";
      document.getElementById("germanLang").style.display = "none";
      document.getElementById("frenchLang").style.display = "none";
      document.getElementById("polishLang").style.display = "none";
      document.getElementById("russianLang").style.display = "none";
    }else if(x == 'spanish'){
      document.getElementById("englishLang").style.display = "none";
      document.getElementById("spanishLang").style.display = "block";
      document.getElementById("germanLang").style.display = "none";
      document.getElementById("frenchLang").style.display = "none";
      document.getElementById("polishLang").style.display = "none";
      document.getElementById("russianLang").style.display = "none";
    }else if(x == 'german'){
      document.getElementById("englishLang").style.display = "none";
      document.getElementById("spanishLang").style.display = "none";
      document.getElementById("germanLang").style.display = "block";
      document.getElementById("frenchLang").style.display = "none";
      document.getElementById("polishLang").style.display = "none";
      document.getElementById("russianLang").style.display = "none";
    }else if(x == 'french'){
      document.getElementById("englishLang").style.display = "none";
      document.getElementById("spanishLang").style.display = "none";
      document.getElementById("germanLang").style.display = "none";
      document.getElementById("frenchLang").style.display = "block";
      document.getElementById("polishLang").style.display = "none";
      document.getElementById("russianLang").style.display = "none";
    }else if(x == 'polish'){
      document.getElementById("englishLang").style.display = "none";
      document.getElementById("spanishLang").style.display = "none";
      document.getElementById("germanLang").style.display = "none";
      document.getElementById("frenchLang").style.display = "none";
      document.getElementById("polishLang").style.display = "block";
      document.getElementById("russianLang").style.display = "none";
    }else if(x == 'russian'){
      document.getElementById("englishLang").style.display = "none";
      document.getElementById("spanishLang").style.display = "none";
      document.getElementById("germanLang").style.display = "none";
      document.getElementById("frenchLang").style.display = "none";
      document.getElementById("polishLang").style.display = "none";
      document.getElementById("russianLang").style.display = "block";
    }else{
      document.getElementById("englishLang").style.display = "block";
      document.getElementById("spanishLang").style.display = "none";
      document.getElementById("germanLang").style.display = "none";
      document.getElementById("frenchLang").style.display = "none";
      document.getElementById("polishLang").style.display = "none";
      document.getElementById("russianLang").style.display = "none";
    }
  }
  return (
    <>
    <Head>
    <title>{props.response.data?.cmsPage?.meta_title}</title>
<meta name="title" content={props.response.data?.cmsPage?.meta_title}/>
<meta name="description" content={props.response.data?.cmsPage?.meta_description}/>
<meta name="keywords" content={props.response.data?.cmsPage?.meta_keywords}/>
<script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
    </Head>
    <div className='exports_project_page'>
    <Container>
    <div class="packege">
<div class="lang-new">
   <div class="language-bx">
    <select class="language-input" id="mySelect" onChange={(e)=>myFunction(e.target.value)}>
      <option value="">Select Language</option>
      <option value="english">English</option>
      <option value="spanish">Spanish</option>
      <option value="german">German</option>
      <option value="french">French</option>
      <option value="polish">Polish</option>
      <option value="russian">Russian</option>
      </select>
      </div><script>
 	</script></div>
</div>
    <div dangerouslySetInnerHTML={{__html:cmsPage}}></div>
    </Container>
    </div>
    </>
  )
}

export default ExportsProject